import { render, staticRenderFns } from "./subPage.vue?vue&type=template&id=1037350f&"
import script from "./subPage.vue?vue&type=script&lang=js&"
export * from "./subPage.vue?vue&type=script&lang=js&"
import style0 from "./subPage.vue?vue&type=style&index=0&id=1037350f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports